import { SaveMessageState } from '../../lib/enums/saveMessage';

export const state = (): Record<string, unknown> => ({
  enabled: false,
  secondaryButton: '',
  continueText: '',
  saveMessageState: SaveMessageState.None,
  allowChanges: true,
  continueButtonLabel: ''
});

export const mutations = {
  setContinueButtonLabel(
    state: any,
    { continueButtonLabel }: { continueButtonLabel: string }
  ): void {
    state.continueButtonLabel = continueButtonLabel;
  },

  setEnabled(state: any, { enabled }: { enabled: boolean }): void {
    state.enabled = enabled;
  },

  setContinueText(
    state: any,
    { continueText }: { continueText: string }
  ): void {
    state.continueText = continueText;
  },

  setSecondaryButton(
    state: any,
    { secondaryButton }: { secondaryButton: string }
  ): void {
    state.secondaryButton = secondaryButton;
  },

  setSaveMessageState(
    state: any,
    { saveMessageState }: { saveMessageState: SaveMessageState }
  ) {
    state.saveMessageState = saveMessageState;
  },

  setAllowChanges(state: any, { allowChanges }: { allowChanges: boolean }) {
    state.allowChanges = allowChanges;
  }
};
